import React, { useEffect } from "react";

function Academics() {
  useEffect(() => {
    document.title = "Academics";
  });
  return (
    <div className="content">
      <div className="w-container">
        <div className="page-head">
          <div className="page-title">
            <h1 className="h1">Academics</h1>
          </div>
        <div class="sub-hrule"></div>
        </div>
        <div className="people-section">
          <div id="paanav" className="from-navbar-ref"></div>
          <div id="paa" className="page-nav-ref"></div>
          <div className="sub-head">
            <h3 className="h3">Peer Academic Advisors (PAAs)</h3>
            <div className="sub-hrule"></div>
            <p className="paragraph-center sub">
              Peer Academic Advisors (PAAs) serve as liaisons between students,
              faculty, and the Office of Academic Advising. Throughout the year,
              they coordinate events to inform students about scheduling,
              research opportunities, and other facets of academic life.
            </p>
          </div>
          <div class="people-grid">
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Brandon_Stroud_Head_PAA.jpeg"
                  height="200"
                  alt="Brandon Stroud"
                />
              </div>
              <div class="name">
                <h4 class="h4">Brandon Stroud</h4>
              </div>
              <div class="subject">
                <p class="position"><strong>Head PAA</strong><br/>Electrical & Computer Engineering</p>
              </div>
              <div>
                <a class="position" href="mailto: bds10@rice.edu">
                  <u>bds10@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Erin Chen.jpg"
                  height="200"
                  alt="Erin Chen"
                />
              </div>
              <div class="name">
                <h4 class="h4">Erin Chen</h4>
              </div>
              <div class="subject">
                <p class="position"><strong>Head PAA</strong><br/>Biosciences, Cell Biology and Genetics<br/>Minor: Cinema and Media Studies</p>
              </div>
              <div>
                <a class="position" href="mailto: ec82@rice.edu">
                  <u>ec82@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/misc/Nathan Chen.jpg"
                  height="200"
                  alt="Nathan Chen"
                />
              </div>
              <div class="name">
                <h4 class="h4">Nathan Chen</h4>
              </div>
              <div class="subject">
                <p class="position"><strong>Head PAA</strong><br/>Neuroscience, Health Sciences</p>
              </div>
              <div>
                <a class="position" href="mailto: nc76@rice.edu">
                  <u>nc76@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Matthew Ochoa O-Week PAA.jpg"
                  height="200"
                  alt="Matthew Ochoa"
                />
              </div>
              <div class="name">
                <h4 class="h4">Matthew Ochoa</h4>
              </div>
              <div class="subject">
                <p class="position">Neuroscience</p>
              </div>
              <div>
                <a class="position" href="mailto: mo57@rice.edu">
                  <u>mo57@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Gabriela Catalina McArthur O-Week PAA.jpg"
                  height="200"
                  alt="Gabriela Catalina McArthur"
                />
              </div>
              <div class="name">
                <h4 class="h4">Gabriela Catalina McArthur</h4>
              </div>
              <div class="subject">
                <p class="position">English<br/>Minors: Medical Humanities, Certificate in Language and Intercultural Communication</p>
              </div>
              <div>
                <a class="position" href="mailto: gm78@rice.edu">
                  <u>gm78@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Anh Tran O-Week PAA.jpg"
                  height="200"
                  alt="Anh Tran"
                />
              </div>
              <div class="name">
                <h4 class="h4">Anh Tran</h4>
              </div>
              <div class="subject">
                <p class="position">Bioscience</p>
              </div>
              <div>
                <a class="position" href="mailto: at227@rice.edu">
                  <u>at227@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Hibah Rahman O-Week PAA.jpeg"
                  height="200"
                  alt="Hibah Rahman"
                />
              </div>
              <div class="name">
                <h4 class="h4">Hibah Rahman</h4>
              </div>
              <div class="subject">
                <p class="position">Bioengineering<br/>Minor: Spanish</p>
              </div>
              <div>
                <a class="position" href="mailto: hr36@rice.edu">
                  <u>hr36@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/White, Zeiona - YLPAA.jpg"
                  height="200"
                  alt="Zeiona White"
                />
              </div>
              <div class="name">
                <h4 class="h4">Zeiona White</h4>
              </div>
              <div class="subject">
                <p class="position">Electrical and Computer Engineering<br/>Minor: Engineering Design</p>
              </div>
              <div>
                <a class="position" href="mailto: zw108@rice.edu">
                  <u>zw108@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Ariel Ramos YLPAA.jpg"
                  height="200"
                  alt="Ariel Ramos"
                />
              </div>
              <div class="name">
                <h4 class="h4">Ariel Ramos</h4>
              </div>
              <div class="subject">
                <p class="position">Electrical and Computer Engineering<br/>Minor: Spanish</p>
              </div>
              <div>
                <a class="position" href="mailto: ar307@rice.edu">
                  <u>ar307@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Olivia Zhao YLPAA.jpg"
                  height="200"
                  alt="Olivia Zhao"
                />
              </div>
              <div class="name">
                <h4 class="h4">Olivia Zhao</h4>
              </div>
              <div class="subject">
                <p class="position">Business & MEOS<br/>Minor: Data Science</p>
              </div>
              <div>
                <a class="position" href="mailto: oz11@rice.edu">
                  <u>oz11@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Eesha Kodavatikanti YLPAA.jpg"
                  height="200"
                  alt="Eesha Kodavatikanti"
                />
              </div>
              <div class="name">
                <h4 class="h4">Eesha Kodavatikanti</h4>
              </div>
              <div class="subject">
                <p class="position">Neuroscience<br/>Minor: Medical Humanities</p>
              </div>
              <div>
                <a class="position" href="mailto: ek81@rice.edu">
                  <u>ek81@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Walters, Kitty - YLPAA.jpg"
                  height="200"
                  alt="Kitty Walters"
                />
              </div>
              <div class="name">
                <h4 class="h4">Kitty Walters</h4>
              </div>
              <div class="subject">
                <p class="position">Bioengineering<br/>Minor: Applied Math</p>
              </div>
              <div>
                <a class="position" href="mailto: kw115@rice.edu">
                  <u>kw115@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Charis Xiong YLPAA.jpg"
                  height="200"
                  alt="Charis Xiong"
                />
              </div>
              <div class="name">
                <h4 class="h4">Charis Xiong</h4>
              </div>
              <div class="subject">
                <p class="position">Statistics<br/>Minors: Data Science, Asian Studies, Korean Certificate</p>
              </div>
              <div>
                <a class="position" href="mailto: cx25@rice.edu">
                  <u>cx25@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Eon Lim YLPAA.jpg"
                  height="200"
                  alt="Eon Lim"
                />
              </div>
              <div class="name">
                <h4 class="h4">Eon Lim</h4>
              </div>
              <div class="subject">
                <p class="position">Biosciences, Sports Medicine</p>
              </div>
              <div>
                <a class="position" href="mailto: ekl3@rice.edu">
                  <u>ekl3@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Pia Saha - YLPAA.jpg"
                  height="200"
                  alt="Pia Saha"
                />
              </div>
              <div class="name">
                <h4 class="h4">Pia Saha</h4>
              </div>
              <div class="subject">
                <p class="position">Bioengineering<br/>Minor: Business</p>
              </div>
              <div>
                <a class="position" href="mailto: ps152@rice.edu">
                  <u>ps152@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Eli Risinger.jpeg"
                  height="200"
                  alt="Eli Risinger"
                />
              </div>
              <div class="name">
                <h4 class="h4">Eli Risinger</h4>
              </div>
              <div class="subject">
                <p class="position">Political Science, Social Policy Analysis</p>
              </div>
              <div>
                <a class="position" href="mailto: er78@rice.edu">
                  <u>er78@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Amanda Yee - YLPAA.jpg"
                  height="200"
                  alt="Amanda Yee"
                />
              </div>
              <div class="name">
                <h4 class="h4">Amanda Yee</h4>
              </div>
              <div class="subject">
                <p class="position">Biosciences<br/>Minor: Environmental Studies</p>
              </div>
              <div>
                <a class="position" href="mailto: ay57@rice.edu">
                  <u>ay57@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/paa-faces/Aoife Shannon YLPAA.jpg"
                  height="200"
                  alt="Aoife Shannon"
                />
              </div>
              <div class="name">
                <h4 class="h4">Aoife Shannon</h4>
              </div>
              <div class="subject">
                <p class="position">Chemical and Biomolecular Engineering<br/>Minor: Business</p>
              </div>
              <div>
                <a class="position" href="mailto: as375@rice.edu">
                  <u>as375@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="people-section">
          <div id="paanav" className="from-navbar-ref"></div>
          <div id="paa" className="page-nav-ref"></div>
          <div className="sub-head">
            <h3 className="h3">Divisional Advisors</h3>
            <div className="sub-hrule"></div>
            <p className="paragraph-center sub">
            Divisional Advisors are faculty associates of Wiess College 
            that are selected by college magisters and the OAA to provide academic 
            advising to Wiessmen prior to declaring their major. These individuals are 
            excellent resources to answer questions about course choices, short and long 
            term planning, graduation requirements, and other educational opportunities. 
            </p>
          </div>
          <div className="da-content">
            <h5 id="paa-content-name" class="h5">
              Name
            </h5>
            <h5 id="paa-content-major-minor-track" class="h5">
              School
            </h5>
            <h5 id="paa-content-email" class="h5">
              Department
            </h5>
            <h5 id="paa-content-year" class="h5">
              Email
            </h5>
            <h5 id="paa-content-test" class="h5">
              Office
            </h5>
            <p id="paa-content-element" class="paa-mentors-data">
              Jung Youn Lee
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Business
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Business
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              jungyoun.lee@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              248 McNair Hall
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Rebecca Schreib
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Engineering
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Computer Science
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              rebecca.j.smith@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              2064 Duncan Hall
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Renata Remos
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Engineering
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Bioengineering
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              renata.ramos@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              1011 Duncan Hall
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Helade Scutti Santos
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Humanities
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Center for Language and Intercultural Communication
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              helade.santos@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              234 Rayzor Hall
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Betul Orcan-Ekmekci
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Natural Sciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Math
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              orcan@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              440 Herman Brown
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Daniel Wagner
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Natural Sciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Biosciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              dswagner@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              351 Anderson Biological Lab
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Tilsa Ore Monago
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Social Sciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Economics
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              tilsa@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              N/A
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Carisaa Zimmerman
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Social Sciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              Psychological Sciences
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              carissa.a.zimmerman@rice.edu
            </p>
            <p id="paa-content-element" class="paa-mentors-data">
              472 Sewall Hall
            </p>
          </div>
        </div>
        <div className="people-section">
          <div id="mentornav" className="from-navbar-ref"></div>
          <div id="mentor" className="page-nav-ref"></div>
          <div className="sub-head">
            <h3 className="h3">Academic Advising Liaison</h3>
            <div className="sub-hrule"></div>
            <p className="paragraph-center sub">
              The OAA liaison works for the Office of Academic Advising  and serves 
              as a person of contact for any general academic advising questions. 
              They are a bridge between Wiessmen and the OAA.
            </p>
          </div>
          <div class="resa-grid">
            <div class="person-card">
              <div class="name">
                <h4 class="h4">Nicole Owens</h4>
              </div>
              <div>
                <a class="position" href="mailto: no25@rice.edu">
                  <u>no25@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Academics;
